const Test = () => {
  return (
    <div id="test" className="block relative w-full h-full text-white">
      <div className="sticky left-0 top-0 w-full h-full z-0 ">
        <video
          src="/images/eventBg.mp4"
          poster="/images/eventBgPoster.webp"
          autoPlay
          loop
          muted
          playsInline
          aria-label="카이노스 바이오케미칼 성능 및 테스트 인증 배경"
          className="!relative w-full h-full min-h-screen object-cover object-center"
        />
      </div>
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto mt-[-93vh] lg:mt-[-80vh] ">
        <div
          id="title"
          className="relative w-full h-fit text-center mb-10 xl:mb-14"
        >
          <h3 className="font-normal">성능 및 테스트 인증</h3>
          <p className="text-secondary my-5 lg:text-lg">
            - Performance testing and certification -
          </p>
          <p className=" lg:text-lg">KTR & KCL 시험연구소 인증서</p>
        </div>
        <div className="relative w-full h-fit max-w-[1300px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          <img src="/images/test1.webp" alt="KTR·KCL 시험연구소 성능 인증서 1" />
          <img src="/images/test2.webp" alt="KTR·KCL 시험연구소 성능 인증서 2" />
          <img src="/images/test3.webp" alt="KTR·KCL 시험연구소 성능 인증서 3" />
          <img src="/images/test4.webp" alt="KTR·KCL 시험연구소 성능 인증서 4" />
        </div>
        <div className=" text-center mt-10">
          <h3 className="font-normal">Certificate</h3>
        </div>
      </div>
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36">
        <div className="relative w-full h-fit max-w-[1300px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-6">
          <img src="/images/test5.webp" alt="MSDS 물질안전보건자료 1" />
          <img src="/images/test6.webp" alt="MSDS 물질안전보건자료 2" />
        </div>
        <div className=" text-center mt-10">
          <h3 className="font-normal text-[#fd6f22]">MSDS</h3>
          <p>(Material Safety Data Sheet)</p>
        </div>
      </div>
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto pb-14 lg:pb-28 xl:pb-36">
        <div className="relative w-full h-fit max-w-[1300px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          <img src="/images/test7.webp" alt="KTR 한국화학융합시험연구원 살균테스트 성적서" />
          <img src="/images/test7.webp" alt="KTR 한국화학융합시험연구원 살균테스트 성적서" />
          <img src="/images/test7.webp" alt="KTR 한국화학융합시험연구원 살균테스트 성적서" />
          <img src="/images/test7.webp" alt="KTR 한국화학융합시험연구원 살균테스트 성적서" />
        </div>
        <div className=" text-center mt-10">
          <h3 className="font-normal text-[#58ccff]">99.9% 탁월한 살균력!</h3>
          <small>현장 살균 테스트 (ATP 측정)</small>
          <p className="mt-3">KTR 한국화학융합시험연구원 살균테스트 </p>
        </div>
      </div>
    </div>
  );
};

export default Test;
